import React from 'react'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { LoadingButton } from '@termly-web/common'

import noop from 'utils/noop'

import BodyLayout from 'components/BodyLayout'
import CenterLayout from 'components/elements/CenterLayout'

import Locale from './locale'
import Styles from './styles.scss'

import dsarIcon from './img/dsar-icon.svg'
import errorIcon from './img/error-icon.svg'
import newWebsiteIcon from './img/icon-new-website.svg'
import noDomainIcon from './img/no-domain-icon.svg'
import noInvoicesIcon from './img/icon-no-invoices.svg'
import scanErrorIcon from './img/scan-failed-icon.svg'
import scanIcon from './img/scan-icon.svg'

const ICONS = {
  dsarForm: dsarIcon,
  error: errorIcon,
  newWebsite: newWebsiteIcon,
  noDomain: noDomainIcon,
  noInvoices: noInvoicesIcon,
  scan: scanIcon,
  scanError: scanErrorIcon,
}


export default function WelcomeGuideLayout(props) {
  const {
    button,
    buttonText,
    description,
    iconType = 'newWebsite',
    isScanning,
    onClickHandler = noop,
    showButton = true,
    title,
  } = props

  const buttonContent = ( isScanning ) ? Locale.scanning : buttonText

  const iconClassName = classnames(Styles.icon, 't-icon')

  const iconSrc = ICONS[iconType] || iconType

  return (
    <BodyLayout>
      <CenterLayout>
        <div className={ Styles.container }>
          <img
            alt=""
            className={ iconClassName }
            src={ iconSrc }
          />
          { renderTitle(title) }
          { renderDescription(description) }
          {
            renderButton({
              button,
              buttonContent,
              handleClick: onClickHandler,
              isScanning,
              showButton,
            })
          }
        </div>
      </CenterLayout>
    </BodyLayout>
  )
}

WelcomeGuideLayout.propTypes = {
  button: PropTypes.node,
  buttonText: PropTypes.shape(FormattedMessage.propTypes),
  description: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.shape({}),
  ]),
  iconType: PropTypes.string,
  isScanning: PropTypes.bool,
  onClickHandler: PropTypes.func,
  showButton: PropTypes.bool,
  title: PropTypes.shape(FormattedMessage.propTypes),
}

function renderTitle(title) {
  if ( !title ) {
    return null
  }

  return (
    <div className={ Styles.title }>
      <FormattedMessage { ...title } />
    </div>
  )
}

function renderDescription(description) {
  if ( !description ) {
    return null
  }

  const renderMessage = () => {
    if ( React.isValidElement(description) ) {
      return description
    }

    const values = {
      break: <br />,
      ...description.values,
    }

    return (
      <FormattedMessage
        { ...description }
        values={ values }
      />
    )
  }

  return (
    <div className={ Styles.description }>
      { renderMessage() }
    </div>
  )
}

function renderButton(args) {
  const {
    button,
    buttonContent,
    handleClick,
    isScanning,
    showButton,
  } = args

  if ( !showButton ) {
    return null
  }

  if ( button ) {
    return (
      <div className={ Styles.preRenderedButton }>
        { button }
      </div>
    )
  }

  const className = classnames(Styles.button, 't-button')
  const disabled = isScanning

  return (
    <LoadingButton
      className={ className }
      color="secondary"
      disabled={ disabled }
      handleClick={ handleClick }
      isLoading={ isScanning }
      type="solid"
    >
      <FormattedMessage
        { ...buttonContent }
      />
    </LoadingButton>
  )
}
